import { Button, ButtonProps, Divider } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

type AddButtonRoundedProps = {
  name: string;
} & ButtonProps;

const AddButtonRounded = (props: AddButtonRoundedProps) => {
  return (
    <Divider>
      <Button
        {...props}
        size="small"
        color="inherit"
        startIcon={<AddIcon style={{ fontSize: 16 }} />}
      >
        {props.name}
      </Button>
    </Divider>
  );
};

export default AddButtonRounded;
